import { render, staticRenderFns } from "./mainclient.vue?vue&type=template&id=0627ad89"
import script from "./mainclient.vue?vue&type=script&lang=js"
export * from "./mainclient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports